export const quickActionBarItemMetaData = {
    mobileOnly: true,
    containableByStructure: true
}
